import { useState } from 'react';
import { formatDuration } from '../lib/format.js';

export default function ConflictModal({ running, newTaskName, onChoose, onCancel }) {
  const [busy, setBusy] = useState(false);

  const choose = async action => {
    setBusy(true);
    try {
      await onChoose(action);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-md bg-panel border border-border rounded-2xl shadow-2xl overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <div className="p-5 border-b border-border">
          <div className="text-xs uppercase tracking-wider text-muted mb-1">Switching tasks</div>
          <div className="text-sm text-text/90 mb-2">
            <span className="text-running font-medium">{running.subTaskName || 'A timer'}</span>
            {running.taskName && <> in <span className="text-text/70">{running.taskName}</span></>} is running.
          </div>
          {newTaskName && (
            <div className="text-sm text-muted">
              About to start: <span className="text-text/90">{newTaskName}</span>
            </div>
          )}
        </div>

        <div className="p-5 space-y-2">
          <button
            disabled={busy}
            onClick={() => choose('complete')}
            className="w-full px-4 py-3 rounded-lg border border-running/40 bg-running/5 hover:bg-running/10 text-left transition-colors"
          >
            <div className="text-sm font-semibold text-running">Mark Complete</div>
            <div className="text-[11px] text-muted mt-0.5">Stop, mark complete, move to today's tasks</div>
          </button>
          <button
            disabled={busy}
            onClick={() => choose('pause')}
            className="w-full px-4 py-3 rounded-lg border border-warn/40 bg-warn/5 hover:bg-warn/10 text-left transition-colors"
          >
            <div className="text-sm font-semibold text-warn">Put On Hold</div>
            <div className="text-[11px] text-muted mt-0.5">Pause, keep in queue to resume later</div>
          </button>
        </div>

        <div className="p-4 border-t border-border bg-panel2/50">
          <button
            disabled={busy}
            onClick={onCancel}
            className="w-full text-sm text-muted hover:text-text py-2"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
